import { useQuery } from 'react-query';
import { Paginated, WebinarParticipant } from 'src/core/types';

import axios from './axios';

const fetchUsers = (id: number, page = 1, search?: string) =>
  axios
    .get<Paginated<WebinarParticipant>>(
      `/posht/yashar/webinars/${id}/viewers/?page=${page}` +
        (search ? `&search=${search}` : ''),
    )
    .then((res) => res.data);

export interface UseWebinarParticipantsProps {
  filters?: Partial<{
    search?: string;
  }>;
  id: number;
  page?: number;
}

export function useWebinarParticipants(props: UseWebinarParticipantsProps) {
  const { filters, id, page } = props;

  return useQuery<Paginated<WebinarParticipant>>(
    ['webinar-participants', id, page, filters?.search],
    async () => {
      return fetchUsers(id, page, filters?.search);
    },
  );
}
